(function () {
  'use strict';

  var RP = window.RP || { routes: { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', root: '/' }, moneyFormat: '£{{amount}}', cartDrawer: true };
  var root = (RP.routes.root || '/').replace(/\/?$/, '/');

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var format = RP.moneyFormat || '£{{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelimiters(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(cents, 2, "'", '.');
        default: return withDelimiters(cents, 2, ',', '.');
      }
    });
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Header: mobile menu + search ---------- */
  function toggleRegion(button, region) {
    if (!button || !region) return;
    button.addEventListener('click', function () {
      var open = region.hidden;
      region.hidden = !open;
      button.setAttribute('aria-expanded', String(open));
      if (open) {
        var input = region.querySelector('input');
        if (input) input.focus();
      }
    });
  }
  toggleRegion(document.querySelector('[data-menu-toggle]'), document.querySelector('[data-mobile-menu]'));
  toggleRegion(document.querySelector('[data-search-toggle]'), document.querySelector('[data-search-panel]'));

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var scrim = document.querySelector('[data-drawer-scrim]');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var close = drawer.querySelector('[data-drawer-close]');
    if (close) close.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function renderCart(cart) {
    updateCount(cart.item_count);
    if (!drawer) return;
    var lines = drawer.querySelector('[data-cart-lines]');
    var subtotal = drawer.querySelector('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    if (!lines) return;
    if (!cart.items.length) {
      lines.innerHTML = '<div class="rp-empty"><p>Your bag is empty.</p><a href="' + root + 'collections/all" class="rp-btn rp-btn--solid">Continue shopping</a></div>';
      return;
    }
    lines.innerHTML = cart.items.map(function (item, i) {
      var img = item.image ? '<img src="' + escapeHtml(item.image.replace(/(\.[a-z]+)(\?|$)/i, '_300x$1$2')) + '" alt="" loading="lazy">' : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<span class="rp-small rp-muted">' + escapeHtml(item.variant_title) + '</span>' : '';
      return '<div class="rp-line">' +
        '<a href="' + escapeHtml(item.url) + '" class="rp-line__thumb">' + img + '</a>' +
        '<div class="rp-line__info">' +
          '<a href="' + escapeHtml(item.url) + '" class="rp-line__title">' + escapeHtml(item.product_title) + '</a>' + variant +
          '<div class="rp-line__controls">' +
            '<div class="rp-qty"><button type="button" data-line="' + (i + 1) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-line="' + (i + 1) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
            '<button type="button" class="rp-link-btn" data-line="' + (i + 1) + '" data-qty="0">Remove</button>' +
          '</div>' +
        '</div>' +
        '<span class="rp-price">' + formatMoney(item.final_line_price) + '</span>' +
      '</div>';
    }).join('');
  }

  function fetchCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function changeLine(line, quantity) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-line]');
      if (btn) {
        btn.disabled = true;
        changeLine(Number(btn.dataset.line), Math.max(0, Number(btn.dataset.qty)));
      }
      if (e.target.closest('[data-drawer-close]')) closeDrawer();
    });
    if (scrim) scrim.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });

    document.querySelectorAll('[data-cart-open]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (document.body.classList.contains('template-cart')) return;
        e.preventDefault();
        fetchCart().then(renderCart).then(openDrawer).catch(function () { window.location.href = link.href; });
      });
    });
  }

  /* Add to bag without leaving the page (falls back to normal form submit) */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!RP.cartDrawer || !drawer) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (e.submitter && e.submitter.name === 'checkout') return;
    e.preventDefault();
    var button = form.querySelector('[type="submit"]');
    var label = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to bag');
        return fetchCart();
      })
      .then(function (cart) { renderCart(cart); openDrawer(); })
      .catch(function (err) {
        var msg = form.querySelector('[data-form-error]');
        if (!msg) {
          msg = document.createElement('p');
          msg.className = 'rp-form-error';
          msg.setAttribute('role', 'alert');
          msg.setAttribute('data-form-error', '');
          form.appendChild(msg);
        }
        msg.textContent = err.message;
      })
      .finally(function () {
        if (button) { button.disabled = false; button.textContent = label; }
      });
  });

  /* ---------- Product page ---------- */
  var productSection = document.querySelector('[data-product-section]');
  var productJson = document.querySelector('[data-product-json]');
  if (productSection && productJson) {
    var product = JSON.parse(productJson.textContent);
    var form = productSection.querySelector('[data-product-form]');
    var idInput = productSection.querySelector('[data-variant-id]');
    var priceEl = productSection.querySelector('[data-price-current]');
    var compareEl = productSection.querySelector('[data-price-compare]');
    var addBtn = productSection.querySelector('[data-add-button]');

    function selectedOptions() {
      return product.options.map(function (_, i) {
        var checked = form.querySelector('input[name="option' + (i + 1) + '"]:checked');
        return checked ? checked.value : null;
      });
    }

    function onOptionChange() {
      var opts = selectedOptions();
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        compareEl.hidden = !(variant.compare_at_price > variant.price);
        compareEl.textContent = variant.compare_at_price ? formatMoney(variant.compare_at_price) : '';
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to bag' : 'Sold out';
      }
      if (variant.featured_media) {
        var media = productSection.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (media) media.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    if (form) {
      form.querySelectorAll('[data-option-input]').forEach(function (input) {
        input.addEventListener('change', onOptionChange);
      });
    }

    productSection.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = productSection.querySelector('input[name="quantity"]');
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(btn.dataset.qtyStep));
      });
    });

    var gallery = productSection.querySelector('.rp-product__gallery');
    if (gallery) gallery.style.setProperty('--n', gallery.children.length);
  }

  /* ---------- Collection sort ---------- */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Pause off-screen videos to save battery ---------- */
  if ('IntersectionObserver' in window) {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting && !reduce) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('video.rp-video').forEach(function (v) {
      if (reduce) { v.removeAttribute('autoplay'); v.pause(); }
      io.observe(v);
    });
  }
})();
